<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/clock (1).svg" width="48" />
                  </div>
                </div>
                <div class="col-md-5 remove-padding-left">
                  <div class="">
                    <h4 class="text-white font-weight mobile_text">
                      {{ $t("text.iAddMaintenance.scheduleMaintenance") }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="pb-3 mt-3 full__row_section">
        <div class="m_wrapper">
          <div class="form_wrapper">
            <div class="row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.type") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <!-- <input v-model="type" readonly type="text"    class="form-control input_full_width" /> -->
                  <select v-model="type">
                    <option value="type" disabled>
                      {{ $t("text.iAddMaintenance.facilityType") }}
                    </option>
                    <option value="Generator">
                      {{ $t("text.iAddMaintenance.generator") }}
                    </option>
                    <option value="Tank System">
                      {{ $t("text.iAddMaintenance.tankSystem") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.generatorName") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <input
                    type="text"
                    v-model="typeName"
                    :placeholder="$t('text.iAddMaintenance.generatorName')"
                    class="form-control input_full_width"
                  />
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.description") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <input
                    type="text"
                    v-model="description"
                    :placeholder="
                      $t('text.iAddMaintenance.maintenanceDescription')
                    "
                    class="form-control input_full_width"
                  />
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.resolved") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <select v-model="resolved">
                    <option value="Resolved" disabled>
                      {{ $t("text.iAddMaintenance.resolved") }}
                    </option>
                    <option value="true">
                      {{ $t("text.iAddMaintenance.true") }}
                    </option>
                    <option value="false">
                      {{ $t("text.iAddMaintenance.false") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.category") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <select v-model="service">
                    <option value="Service">
                      {{ $t("text.iAddMaintenance.service") }}
                    </option>
                    <!-- <option value="true">{{$t('text.iAddMaintenance.true')}}</option>
                                <option value="false">{{$t('text.iAddMaintenance.false')}}</option> -->
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3">
                <h6>{{ $t("text.iAddMaintenance.dueDate") }}</h6>
              </div>
              <div class="col-md-9">
                <div class="input__block input_width_shrink">
                  <vue-ctk-date-time-picker
                    id="DateTimePicker"
                    v-model="scheduleDateTime"
                    color="#370F70"
                    :locale="this.$root.$i18n.locale"
                    format="YYYY-MM-DD h:mm a"
                    formatted="DD/MM/YYYY h:mm a"
                    :label="$t('text.calendar.selectDateAndTime')"
                    position="top"
                    :min-date="minDate"
                  />
                </div>
              </div>
            </div>
            <div class="mt-5 row justify-content-center align-items-center">
              <div class="col-md-3"></div>
              <div class="col-md-9">
                <div class="mt-4 text-center">
                  <button
                    class="vue_router_link btn btn_theme"
                    @click="scheduleMaintenance($event)"
                  >
                    {{ $t("text.iAddMaintenance.schedule") }}
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Add Maintenance:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      backImg,
      minDate: this.$moment(new Date())
        .subtract(1, "days")
        .format("YYYY-MM-DD"),

      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      industryBranch: null,
      industryBranchId: null,
      type: "type",
      typeName: null,
      resolved: "Resolved",
      service: "Service",
      scheduleDateTime: "",
      description: null,
    };
  },
  created() {
    this.$eventHub.$on("link", (url) => {
      if (this.$route.name == url) {
        return;
      }
      this.$router.push({
        name: url,
        query: {
          branchId: this.$route.query.branchId,
          groupId: this.$route.query.groupId,
          companyId: this.$route.query.companyId,
        },
      });
    });
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Add Maintenance - ${industryBranch.name}`;
    });

    this.getToday();
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
      }
    },
  },
  mounted() {},
  methods: {
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.scheduleDateTime = todaysDate;
    },
    scheduleMaintenance($event) {
      $event.preventDefault();
      if (this.type === "type") {
        this.$toast.open({
          message: this.$t("text.iAddMaintenance.facilityTypeMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.typeName) {
        this.$toast.open({
          message: this.$t("text.iAddMaintenance.generatorTypeNameMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.description) {
        this.$toast.open({
          message: this.$t("text.iAddMaintenance.descriptionMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.resolved === "Resolved") {
        this.$toast.open({
          message: this.$t("text.iAddMaintenance.trueOrFalse"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.scheduleDateTime) {
        this.$toast.open({
          message: this.$t("text.errors.dateMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.resolved === "true") {
        this.resolved = true;
      } else {
        this.resolved = false;
      }

      $(".loader").show();

      const dateTime = this.$moment(`${this.scheduleDateTime}`).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let newDateTime = new Date(dateTime);
      let updatedDateTime = new Date(
        newDateTime.setHours(newDateTime.getHours() + 1)
      ).toISOString();
      let date = updatedDateTime;

      const data = {
        type: this.type,
        typeName: this.typeName,
        branchId: this.industryBranchId,
        resolved: this.resolved,
        service: this.service,
        scheduleDate: date,
        description: this.description,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/RecordRequest`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.iAddMaintenance.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "industrialBranchSchedule_maintenace",
            query: {
              branchId: this.$route.query.branchId,
              companyId: this.$route.query.companyId,
              groupId: this.$route.querygroupId,
            },
          });
        })
        .catch((error) => {
          $(".loader").hide();
        });
    },
  },
};
</script>
